import withNameResolver from './NameResolver.component';

export default withNameResolver;
